const LineIcon = ({ size = 40 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="12" fill="#06C755" />
    <path d="M39 22.08C39 15.27 32.28 9.75 24 9.75C15.72 9.75 9 15.27 9 22.08C9 28.19 14.28 33.28 21.36 34.21C21.87 34.32 22.56 34.55 22.74 34.98C22.9 35.37 22.84 35.97 22.79 36.35L22.57 37.6C22.5 38.02 22.22 39.29 24 38.55C25.78 37.81 32.68 33.56 35.79 30.01C37.86 27.74 39 25.05 39 22.08Z" fill="white" />
    <path d="M21.06 19.13H19.95C19.75 19.13 19.58 19.29 19.58 19.5V25.61C19.58 25.82 19.75 25.98 19.95 25.98H21.06C21.27 25.98 21.43 25.82 21.43 25.61V19.5C21.43 19.29 21.27 19.13 21.06 19.13Z" fill="#06C755" />
    <path d="M28.15 19.13H27.04C26.83 19.13 26.67 19.29 26.67 19.5V23.23L23.7 19.27C23.69 19.25 23.67 19.23 23.66 19.21L23.64 19.19L23.61 19.17L23.59 19.16L23.56 19.15L23.54 19.14H23.52H23.5H23.48H22.39C22.18 19.13 22.02 19.29 22.02 19.5V25.61C22.02 25.82 22.18 25.98 22.39 25.98H23.5C23.71 25.98 23.87 25.82 23.87 25.61V21.88L26.85 25.85C26.89 25.9 26.94 25.94 26.99 25.96L27.01 25.97L27.05 25.98H28.15C28.36 25.98 28.52 25.82 28.52 25.61V19.5C28.52 19.29 28.36 19.13 28.15 19.13Z" fill="#06C755" />
    <path d="M18.76 24.13H16.39V19.5C16.39 19.29 16.23 19.13 16.02 19.13H14.91C14.7 19.13 14.54 19.29 14.54 19.5V25.61C14.54 25.71 14.58 25.8 14.65 25.87C14.72 25.94 14.81 25.98 14.91 25.98H18.76C18.97 25.98 19.13 25.82 19.13 25.61V24.5C19.13 24.29 18.97 24.13 18.76 24.13Z" fill="#06C755" />
    <path d="M33.45 20.98C33.66 20.98 33.82 20.82 33.82 20.61V19.5C33.82 19.29 33.66 19.13 33.45 19.13H29.6C29.5 19.13 29.41 19.17 29.34 19.24C29.27 19.31 29.23 19.4 29.23 19.5V25.61C29.23 25.71 29.27 25.8 29.34 25.87C29.41 25.94 29.5 25.98 29.6 25.98H33.45C33.66 25.98 33.82 25.82 33.82 25.61V24.5C33.82 24.29 33.66 24.13 33.45 24.13H31.08V23.48H33.45C33.66 23.48 33.82 23.32 33.82 23.11V22C33.82 21.79 33.66 21.63 33.45 21.63H31.08V20.98H33.45Z" fill="#06C755" />
  </svg>
);

export default function LineSupport() {
  return (
    <section className="lp__line-support">
      <div className="lp__line-support__card">
        <div className="lp__line-support__header">
          <LineIcon size={40} />
          <h2 className="lp__line-support__title">お困りごとサポート</h2>
        </div>
        <div className="lp__line-support__divider" />
        <p className="lp__line-support__desc">
          たっぷの使い方やプラン・お支払いに関するご質問、
          端末の不具合など、お困りのことがございましたら
          公式LINEからお気軽にご連絡ください。
          <br />
          解約やプラン変更のお手続きもこちらから承ります。
        </p>
        <a
          href="https://lin.ee/zA7vyIp"
          className="lp__line-support__btn"
          target="_blank"
          rel="noopener noreferrer"
        >
          <LineIcon size={28} />
          公式LINEで相談する
        </a>
        <div className="lp__line-support__badges">
          <div className="lp__line-support__badge">
            <span className="lp__line-support__badge-label">24時間受付</span>
          </div>
          <div className="lp__line-support__badge">
            <span className="lp__line-support__badge-label">チャットで簡単</span>
          </div>
          <div className="lp__line-support__badge">
            <span className="lp__line-support__badge-label">迅速対応</span>
          </div>
        </div>
      </div>
    </section>
  );
}
